import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { of, throwError as observableThrowError, Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { HttpCacheService } from './http-cache.service';

import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrganizationDataService {

  CACHE_KEY = 'ORGANIZATION';
  CACHE_TTL = 3600;

  private urlOrganization = environment.urlWebServices + '/api/organization';

  constructor(
    private http: HttpClient,
    private httpCacheService: HttpCacheService
  ) { }

  read(organizationId: number): Observable<any> {

    // Check cache
    const cachedInfo = this.httpCacheService.get(this.CACHE_KEY);
    if (cachedInfo) return of(cachedInfo);

    // Call web service
    const url = `${this.urlOrganization}/${organizationId}`;
    return this.http.get(url)
      .pipe(
        map(response => this.fixFromMySQL(response)),
        tap(response => this.httpCacheService.set(this.CACHE_KEY, response, this.CACHE_TTL)),
        catchError(error => observableThrowError(error.message || error))
      );
  }

  private fixFromMySQL(response: any): any {

    // For security reasons, pass only safe data
    const organization = {
      Code: response.Code,
      Country: response.Country,
      Currency: response.Currency,
      HomeLink: response.HomeLink,
      Name: response.Name,
      OrganizationId: response.OrganizationId,
      Timezone: response.Timezone,
      URL: response.URL
    }
    return organization;
  }
}
